import { useContext, useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import { Badge, Button } from "flowbite-react";
import { deleteMerchItem } from "../../../services/merchManager/merchManagerActions";
import { CustomModal } from "../../../layouts/customModal";
import { CircleCaution, Trash } from "../../../layouts/icons";
import { ResponseContext } from "../../../context/responseProvider";
import { StatusContext } from "../../../context/statusProvider";
import { useVerifiedUser } from "../../../hooks/useVerifiedUser";

export const DeleteMerchForm = ({ item }) => {
  const modalRef = useRef(null);
  const openRef = useRef(null);
  const { handleApi } = useContext(StatusContext);
  const [isLoading, setIsLoading] = useState(false);
  const { getResponse, setResponse } = useContext(ResponseContext);
  const { isVerified } = useVerifiedUser(["merch_editor"]);

  const handleDelete = (e) => {
    e.preventDefault();
    deleteMerchItem({
      isVerified,
      itemId: item.id,
      email: localStorage.getItem("userEmail"),
      setIsLoading,
      setResponse,
      onSuccess: () => {
        handleApi();
        handleClose();
      },
    });
  };

  const handleClose = () => {
    modalRef.current();
  };

  return (
    <CustomModal
      btnText={"Delete"}
      modalRef={modalRef}
      openRef={openRef}
      customBtn={
        <div id="modalBtn">
          <Button
            onClick={() => {
              openRef.current();
            }}
          >
            <Trash />
            {"Delete"}
          </Button>
        </div>
      }
    >
      <form onSubmit={handleDelete}>
        <Dialog.Title
          as="h3"
          className="text-lg font-medium leading-6 text-gray-900 inline-flex"
        >
          <strong className="flex align-middle">
            <CircleCaution />
            Delete Item
          </strong>
        </Dialog.Title>

        <div className="mt-2">
          <p className="text-sm text-gray-500">
            <span>
              Are you sure you want to delete{" "}
              <strong className="break-words">{item.item_name}</strong> ? This
              action cannot be undone.
            </span>
          </p>
        </div>

        <div className="mt-2">
          {getResponse("delete_merch")?.status === false && (
            <Badge color="failure">
              {getResponse("delete_merch")?.message}
            </Badge>
          )}
        </div>

        <div className="mt-4 inline-flex gap-3">
          <button
            className="text-sm font-semibold"
            type="button"
            onClick={handleClose}
          >
            Cancel
          </button>
          <Button type="submit" disabled={isLoading}>
            {isLoading ? "Deleting..." : "Confirm"}
          </Button>
        </div>
      </form>
    </CustomModal>
  );
};
